import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";

import CurrencyInput from "./NumberInputs/CurrencyInput";
import NumberInput from "./NumberInputs/NumberInput";
import LoginInput from "./LoginInput/LoginInput";
import DropDownInput from "./DropDown/DropDownInput";
import DropDownList from "./DropDown/DropDownList";
import DateInput from "./Date/DateInput";
import { Calendar } from "./Date/Calendar/Calendar";
import VIN from "./VIN/VIN";
import styles from "./FormField.module.css";
import infoBubbleOn from "./Notification_Information.svg";
import infoBubbleOff from "./icon-rounded-outline-info.svg";


class FormField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inFocus: false,
      inError: props.inError,
      showDropDown: false,
      showInfoBubble: false,
      value: props.value,
      highlightedItem: 0
    };

    this.focusFromChild = false;

    this.handleChangeRequest = this.handleChangeRequest.bind(this);
    this.handlePasteRequest = this.handlePasteRequest.bind(this);
    this.handleFocusRequest = this.handleFocusRequest.bind(this);
    this.handleErrorRequest = this.handleErrorRequest.bind(this);
    this.handleDropDownRequest = this.handleDropDownRequest.bind(this);
    this.handleInfoRequest = this.handleInfoRequest.bind(this);
    this.handleDropDownHighlightRequest = this.handleDropDownHighlightRequest.bind(
      this
    );
  }

  getValueFromRegex(regex, newValue, oldValue){
    newValue = newValue.split("_")[0];
    let regexArray = [...this.getPlaceHolderFromRegex(regex)];
    let changedValueArray = [...newValue];
    let oldValueArray = [...oldValue];
    [...newValue].forEach((char, index) => {
      if(regexArray[index+1] !== " "){
        if(changedValueArray.length > oldValueArray.length)
          changedValueArray[index+1] = regexArray[index+1];
        return changedValueArray.join();
      }
    });
    return changedValueArray.join('');
  }

  getPlaceHolderFromRegex(regex){
    var char="";
    var getLength=false;
    var placeholder = "";
    var previousChar = "";
    [...regex].forEach(
        a => {
            if(getLength){
                for(var x = 0; x<parseInt(a); x++){
                    placeholder += char;
                }
                getLength = false;
            }
            if (a === "[") { char =" "}
            if (a === "{") { getLength = true}
            if(["-"].includes(a) && previousChar === "["){ placeholder += a }
            previousChar = a;
        }
    );
    return placeholder;
  }

  handlePasteRequest(e){
    this.props.onChange(e.target.value);
  }

  handleChangeRequest(e, value, itemHighlight) {
      let changeValue;
      if (this.props.fieldType === "DropDown") {
      if (!!e.target) {
        this.focusFromChild = e.target.tagName.toLowerCase() !== "input";
        changeValue = value;
      } else {
        changeValue = e;
      }
    } else {
      changeValue =
        !!e.target && (!!e.target.value || e.target.value === "")
          ? e.target.value
          : e;
    }

    if (this.props.onChange !== undefined) {
      if (this.props.mask != null){
        changeValue = this.getValueFromRegex(this.props.mask, changeValue, this.props.value);
        changeValue = changeValue.split("_")[0];
      }

        if (this.props.groupField === "MiscFee" || this.props.groupField === "pre1981" ){
        this.props.onChange(changeValue, this.props);  
      }
      else{
        this.props.onChange(changeValue);
      }

      if (itemHighlight !== undefined) {
        this.setState({ highlightedItem: itemHighlight });
      }
      if (this.props.fieldType === "DatePicker") {
        this.setState({ showDropDown: false });
      }
    } else {
      if (itemHighlight !== undefined) {
        this.setState({ value: changeValue, highlightedItem: itemHighlight });
      } else {
        if (this.props.fieldType === "DatePicker") {
          this.setState({ value: changeValue, showDropDown: false });
        } else {
          this.setState({ value: changeValue });
        }
      }
    }
  }

  handleFocusRequest(e, inError) {
    let isFocus = e.type === "focus";

    if (isFocus) {
      if (this.props.fieldType === "DropDown") {
        if (this.focusFromChild) {
          this.focusFromChild = false;
          this.setState({ showDropDown: false });
        } else {
          this.setState({ inFocus: isFocus, showDropDown: true });
        }
      } else {
        if (this.props.fieldType === "DatePicker" && this.state.showDropDown) {
        } else {
          this.setState({ inFocus: isFocus });
        }
      }
      this.props.onFocus && this.props.onFocus(e);
    } else {
      if (!!e.relatedTarget) {
        let isRequiredMissing =
          !isFocus && this.props.isRequired && e.target.value === "";
        if (
          this.props.fieldType === "DropDown" &&
          !this.state.value.text &&
          this.state.value !== ""
        ) {
          this.setState({
            inFocus: isFocus,
            inError: isRequiredMissing || !!inError,
            showDropDown: false,
            showInfoBubble: false,
            value: ""
          });
        } else {
          this.setState({
            inFocus: isFocus,
            inError: isRequiredMissing || !!inError,
            showDropDown: false,
            showInfoBubble: false
          });
        }
      }
      this.props.onBlur && this.props.onBlur(e);
    }
  }

  handleErrorRequest(value) {}

  handleDropDownRequest(e) {
    if (this.state.showDropDown) {
      this.focusFromChild = true;
    }

    this.setState(function(prevState, props) {
      return { showDropDown: !prevState.showDropDown };
    });
  }

  handleInfoRequest(e) {
    this.setState((prevState, props) => ({
      showInfoBubble: !prevState.showInfoBubble
    }));
  }

  handleDropDownHighlightRequest(request) {
    let highlightItem;
    if (isNaN(request)) {
      if (request === "Enter") {
        let selectedValue = this.props.items[this.state.highlightedItem];
        this.setState({ value: selectedValue });
        return;
      } else if (request === "ArrowDown") {
        highlightItem = Math.min(
          this.state.highlightedItem + 1,
          this.props.items.length - 1
        );
      } else {
        highlightItem = Math.max(this.state.highlightedItem - 1, 0);
      }
    } else {
      highlightItem = request;
    }

    if (highlightItem !== this.state.highlightedItem) {
      this.setState({ highlightedItem: highlightItem });
    }
  }

  componentDidMount() {
    if (!!this.props.items && this.props.value !== "") {
      let foundIndex;

      if (typeof this.props.items[0] === "string") {
        foundIndex = this.props.items.findIndex(
          item =>
            item === this.props.value.value && item === this.props.value.text
        );
      } else {
        foundIndex = this.props.items.findIndex(
          item =>
            item.value === this.props.value.value &&
            item.text === this.props.value.text
        );
      }

      foundIndex = Math.max(0, foundIndex);
      this.setState({ highlightedItem: foundIndex });
    }
  }

  static getDerivedStateFromProps(props, state) {
    const incomingValue = get(props, "value.text", props.value);
    const currentValue = get(state, "value.text", state.value);
    if (currentValue !== incomingValue) {
      return { value: props.value };
    }
    return null;
  }

  render() {
    let inputField,
      dropDown,
      frameStyle,
      title,
      infoBubble,
      required = this.props.isRequired ? (
        <span className={styles.required}>*</span>
      ) : (
        undefined
      ),
      textValue = !!this.state.value
        ? !!this.state.value.text
          ? this.state.value.text
          : this.state.value
        : "";

    if (this.props.isDisabledReadOnly) {
      frameStyle = styles.locked;
    } else if (this.state.inError) {
      frameStyle = styles.error;
    } else {
      frameStyle = this.state.inFocus ? styles.focusedFrame : styles.frame;
    }
    switch (this.props.fieldType) {
      case "Currency":
        let currencyValue = textValue === "" ? 0 : textValue;

        inputField = (
          <CurrencyInput
            id={this.props.id}
            value={currencyValue}
            currencyCode={this.props.currencyCode}
            languageCode={this.props.languageCode}
            isDisabledReadOnly={this.props.isDisabledReadOnly}
            maxValue={this.props.maxValue}
            name={this.props.name}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            disabled={this.props.disabled}
          />
        );
        break;
      case "Number":
        let numberValue = textValue === "" ? undefined : textValue;

        inputField = (
          <NumberInput
            id={this.props.id}
            value={numberValue}
            languageCode={this.props.languageCode}
            isFormatted={this.props.isFormattedNumber}
            isDisabledReadOnly={this.props.isDisabledReadOnly}
            maxValue={this.props.maxValue}
            minValue={this.props.minValue}
            name={this.props.name}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            disabled={this.props.disabled}
          />
        );

        break;
      case "DropDown":
        inputField = (
          <DropDownInput
           id={this.props.id}
            value={textValue}
            isOpen={this.state.showDropDown}
            isDisabledReadOnly={this.props.isDisabledReadOnly}
            placeholder={this.props.placeholder}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            onDropDownRequest={this.handleDropDownRequest}
            onHighlightChange={this.handleDropDownHighlightRequest}
            disabled={this.props.disabled}
          />
        );

        dropDown = (
          <DropDownList
            id={this.props.id}
            items={this.props.items}
            value={this.state.value}
            isOpen={this.state.showDropDown}
            highlightedItem={this.state.highlightedItem}
            onSelected={this.handleChangeRequest}
            onHighlightChange={this.handleDropDownHighlightRequest}
            disabled={this.props.disabled}
          />
        );
        break;
      case "DatePicker":
        if(textValue !== "" && Object.prototype.toString.call(new Date(textValue)) === "[object Date]")
        {
          var parts = textValue.split('-');
          textValue = new Date(parts[0], parts[1] - 1, parts[2]); 
        }
        let calendarValue = textValue === "" ? new Date() : textValue;

        inputField = (
          <DateInput
            id={this.props.id}
            value={textValue}
            languageCode={this.props.languageCode}
            isOpen={this.state.showDropDown}
            isDisabledReadOnly={this.props.isDisabledReadOnly}
            name={this.props.name}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            onDropDownRequest={this.handleDropDownRequest}
            disabled={this.props.disabled}
          />
        );

        const { minDate, maxDate } = this.props;

        dropDown = (
          <Calendar
            id={this.props.id}
            isOpen={this.state.showDropDown}
            locale={this.props.languageCode}
            value={calendarValue}
            onChange={this.handleChangeRequest}
            maxDate={maxDate}
            minDate={minDate}
            disabled={this.props.disabled}
          />
        );
        break;
      case "UserId":
      case "Password":
      case "Email":
        inputField = (
          <LoginInput
          id={this.props.id}
            type={this.props.fieldType}
            value={textValue}
            maxLength={this.props.maxLength}
            name={this.props.name}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            onError={this.handleErrorRequest}
            disabled={this.props.disabled}
          />
        );

        frameStyle = [frameStyle, styles.reverse].join(" ");
        break;
      case "VIN":
        inputField = (
          <VIN
            id={this.props.id}
            value={textValue}
            name={this.props.name}
            onFocus={this.handleFocusRequest}
            onChange={this.handleChangeRequest}
            disabled={this.props.disabled}
          />
        );
        break;
      default:
        inputField = (
          <input
            id={this.props.id}
            type="text"
            className={styles.text}
            value={textValue}
            maxLength={this.props.maxLength}
            data-inputmask-regex={this.props.mask}
            name={this.props.name}
            placeholder={this.props.mask != null ? this.getPlaceHolderFromRegex(this.props.mask) :this.props.placeholder}
            readOnly={this.props.isDisabledReadOnly}
            required={this.props.isRequired}
            onChange={this.handleChangeRequest}
            onFocus={this.handleFocusRequest}
            onBlur={this.handleFocusRequest}
            onPaste={this.handlePasteRequest}
            onKeyUp={this.props.onKeyUp}
            disabled={this.props.disabled}
            autoComplete="nope"
          />
        );
        break;
    }

    if (!!this.props.children) {
      let infoGlyph = this.state.showInfoBubble ? infoBubbleOn : infoBubbleOff;

      if (this.state.showInfoBubble) {
        infoBubble = (
          <div className={styles.infoBubble}>{this.props.children}</div>
        );
      }

      title = (
        <div className={styles.titleInfo}>
          <span>
            <span className={styles.title}>{this.props.title}</span>
            {required}
          </span>
          <img
            className={styles.infoGlyph}
            src={infoGlyph}
            alt=""
            onClick={this.handleInfoRequest}
          />
        </div>
      );
    } else {
      title = (
        <React.Fragment>
          <span className={styles.title} id={`${this.props.title}-label`}>{this.props.title}</span>
          {required}
        </React.Fragment>
      );
    }

    let style = this.props.fieldType === "VIN" ? styles.vin : styles.component;

    return (
      <label className={[style, this.props.styleName].join(" ")}>
        {infoBubble}
        {title}
        <div className={frameStyle}>{inputField}</div>
        {dropDown}
      </label>
    );
  }
}

FormField.propTypes = {
  fieldType: PropTypes.oneOf([
    "Text",
    "Number",
    "Currency",
    "UserId",
    "Password",
    "Email",
    "DropDown",
    "DatePicker",
    "VIN"
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({ value: PropTypes.any, text: PropTypes.string }),
    PropTypes.instanceOf(Date)
  ]),
  languageCode: PropTypes.string,
  currencyCode: PropTypes.string,
  items: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string)
  ]),
  maxLength: PropTypes.number,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  placeholder: PropTypes.string,
  isFormattedNumber: PropTypes.bool,
  isRequired: PropTypes.bool,
  inError: PropTypes.bool,
  isDisabledReadOnly: PropTypes.bool,
  title: PropTypes.string.isRequired,
  name: PropTypes.string,
  styleName: PropTypes.string,
  onChange: PropTypes.func
};

FormField.defaultProps = {
  fieldType: "Text",
  value: ""
};

export default FormField;
